import { type AnyAction, combineReducers } from 'redux';

import {
    setAudioEnhancementLoadingForSceneGroup,
    setAudioEnhancementStatusForSceneGroup,
} from 'js/src/data/audio-enhancement/audio-enhancement-actions';
import type { AUDIO_ENHANCEMENT_TOGGLE_STATUS } from 'js/src/data/audio-enhancement/audio-enhancement-types';

type AudioEnhancementStatusBySceneGroup = Readonly<Record<string, AUDIO_ENHANCEMENT_TOGGLE_STATUS>>;
type AudioEnhancementLoading = Readonly<{ isLoading: boolean; abortController?: AbortController }>;
type AudioEnhancementLoadingBySceneGroup = Readonly<Record<string, AudioEnhancementLoading>>;

const NO_STATUSES: AudioEnhancementStatusBySceneGroup = {};
const NOTHING_LOADING: AudioEnhancementLoadingBySceneGroup = {};

// this reducer controls the on/off state of the audio enhancement toggle
export function audio_enhancement_status(
    state: AudioEnhancementStatusBySceneGroup = NO_STATUSES,
    action: AnyAction,
): AudioEnhancementStatusBySceneGroup {
    if (setAudioEnhancementStatusForSceneGroup.match(action)) {
        const { sceneGroupId, status } = action.payload;
        if (state[sceneGroupId] === status) {
            return state;
        }
        return { ...state, [sceneGroupId]: status };
    }

    return state;
}

// this reducer controls the loading icon for the audio enhancement controls
export function AUDIO_ENHANCEMENT_LOADING(
    state: AudioEnhancementLoadingBySceneGroup = NOTHING_LOADING,
    action: AnyAction,
): AudioEnhancementLoadingBySceneGroup {
    if (setAudioEnhancementLoadingForSceneGroup.match(action)) {
        const { sceneGroupId, isLoading, abortController } = action.payload;
        return { ...state, [sceneGroupId]: { isLoading, abortController } };
    }

    return state;
}

export const audio_enhancement = combineReducers({
    audio_enhancement_status,
    AUDIO_ENHANCEMENT_LOADING,
});

export type AudioEnhancementState = ReturnType<typeof audio_enhancement>;
